var React = require('react');

function IconCheck16x16 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.33331 8.10564L5.73525 12.6667L14.6666 3.33337","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconCheck16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconCheck16x16;

IconCheck16x16.default = IconCheck16x16;
